export const EMAIL = "northshorescholars@gmail.com";

export const SUBJECTS_TICKER = [
    "English",
    "Economics",
    "Mathematics",
    "Physics",
    "Chemistry",
    "Biology",
    "Geography",
    "Engineering Studies",
    "K–10 General Support",
    "Online & In-Person",
    "North Shore, Sydney",
];

export const TUTORS = [
    {
        id: "oliver",
        name: "Oliver Dean",
        atar: "97",
        role: "Environmental Engineering & Commerce, UNSW",
        school: "Knox Grammar School — Class of 2025",
        honours: ["ATAR 97", "Dux of Geography — Year 12"],
        experience: [
            "Senior School Tutor at Knox Grammar School, supporting Years 11–12 (Mar 2026 – current)",
        ],
        bio: "Oliver is a 19-year-old Environmental Engineering and Commerce student at UNSW and a graduate of Knox Grammar School, where he achieved an ATAR of 97 and was Dux of Geography in Year 12. Having recently completed the HSC himself, he understands the demands of senior school and the importance of effective assessment and exam preparation. His tutoring approach is relaxed and personalised, focusing on each student's current coursework, upcoming assessments and individual areas for improvement. Outside of university and tutoring, Oliver enjoys playing guitar, keeping active and spending time with friends.",
        subjects: [
            "Years K–10 — General (any subject)",
            "Years 11 & 12 — Economics",
            "Years 11 & 12 — Physics",
            "Years 11 & 12 — Geography",
            "Years 11 & 12 — Maths (Standard)",
            "Years 11 & 12 — English (Advanced)*",
            "Years 11 & 12 — Engineering Studies",
        ],
        availability: [
            { day: "Tuesday", time: "3:00 – 8:00 pm" },
            { day: "Thursday", time: "7:00 – 8:00 pm" },
            { day: "Friday", time: "3:00 – 8:00 pm" },
            { day: "Saturday", time: "3:00 – 8:00 pm" },
        ],
        library: "Gordon & Macquarie University libraries",
        portrait: "/images/oliver.png",
    },
    {
        id: "ashton",
        name: "Ashton Fairbanks",
        atar: "95",
        role: "Environmental Engineering, UNSW",
        school: "Knox Grammar School — Class of 2025",
        honours: ["ATAR 95", "Dux of Geography — Year 11", "100+ private sessions"],
        experience: [
            "100+ private tutoring sessions completed",
            "Tutor Doctor North Shore (Feb 2026 – current) — Year 11 Biology, Year 9 general, Year 11 Chemistry",
            "Alchemy Tuition (Feb 2026 – current) — Year 11 Chemistry, Year 6 general, previously Year 4 Maths",
        ],
        bio: "Ashton is a 19-year-old Environmental Engineering student at UNSW and a graduate of Knox Grammar School, where he achieved an ATAR of 95 and was Dux of Geography in Year 11. Based in Wahroonga, he has extensive tutoring experience across Biology, Chemistry, Mathematics and general K–12 coursework. Having recently completed high school himself, Ashton understands the challenges students face and aims to create a relaxed, supportive environment while helping students build both understanding and confidence. Outside of tutoring he enjoys gym, surfing, basketball, tennis, skateboarding, AFL and soccer, as well as reading and video games.",
        subjects: [
            "Years K–10 — General (any subject)",
            "Years 11 & 12 — Biology",
            "Years 11 & 12 — Chemistry",
            "Years 11 & 12 — Geography",
            "Years 11 & 12 — Physics",
            "Years 11 & 12 — English (Advanced)*",
        ],
        availability: [
            { day: "Wednesday (immediate)", time: "6:30 – 8:00 pm" },
            { day: "Friday (immediate)", time: "3:00 – 8:00 pm" },
            { day: "Sunday (immediate)", time: "3:00 – 4:00 pm" },
            { day: "Monday (on request)", time: "7:00 – 8:00 pm" },
            { day: "Tuesday (on request)", time: "3:00 – 6:30 pm" },
            { day: "Wednesday (on request)", time: "3:00 – 6:00 pm" },
        ],
        library: "Hornsby Library",
        portrait: "/images/ashton.png",
    },
];

export const PRICING = [
    {
        id: "online",
        name: "Online",
        detail: "via Google Meet",
        tiers: [
            { duration: "1 hour", price: "$55" },
            { duration: "1.5 hours", price: "$80" },
            { duration: "2 hours", price: "$100" },
        ],
    },
    {
        id: "in-person",
        name: "In Person",
        detail: "home or local library",
        tiers: [
            { duration: "1 hour", price: "$70" },
            { duration: "1.5 hours", price: "$100" },
            { duration: "2 hours", price: "$130", note: "special deal" },
        ],
    },
];

export const METHOD_STEPS = [
    {
        n: "01",
        title: "Current coursework first",
        body: "We begin with the key topics, questions and concepts the student has identified from recent schoolwork — making sure they understand what they are learning right now.",
    },
    {
        n: "02",
        title: "Assessments & past papers",
        body: "Next we prioritise upcoming assessments, assignments and relevant past-paper questions, so students prepare effectively for what is actually coming up at school.",
    },
    {
        n: "03",
        title: "Targeted trouble spots",
        body: "We work through any challenging areas the student has identified, with targeted explanations and practice that build both understanding and confidence.",
    },
    {
        n: "04",
        title: "Revision & extension",
        body: "With priorities covered, the tutor draws on knowledge of the student's progress to provide additional targeted work — revision, extension questions and exam-style practice.",
    },
];

export const REVIEWS = [
    {
        text: "Oliver and Ashton have been a game changer for our family. Oliver's targeted focus on HSC Economics and Maths gave our son the structured revision and confidence he needed right before assessments. Highly recommend North Shore Scholars!",
        author: "Georgia M.",
    },
    {
        text: "Finding high-quality, reliable K–12 tutoring that doesn't break the bank is tough, but Ashton and Oliver deliver exceptional value. Ashton's private sessions in Chemistry and Biology made complex concepts clear for our Year 11 daughter.",
        author: "Lucas T.",
    },
    {
        text: "The personalised approach is what sets them apart. Rather than forcing a rigid curriculum, they adapt every session to whatever schoolwork or upcoming exam our child is working on. The 10-session written progress updates were also fantastic for keeping us in the loop.",
        author: "Sarah P.",
    },
    {
        text: "Ashton has been fantastic with our Year 11 daughter. His extensive background in Chemistry and Biology, combined with his relatable approach, helped her grasp difficult concepts quickly and boost her test scores.",
        author: "David L.",
    },
    {
        text: "Flexible scheduling, clear communication, and outstanding results. Having the choice between in-person home visits and Google Meetings online made fitting weekly tutoring into our busy schedule completely seamless.",
        author: "Emma K.",
    },
];

export const LOCATIONS = [
    {
        title: "Your home",
        body: "In-person sessions within roughly a 15-minute drive across the North Shore (at the tutor's discretion).",
    },
    {
        title: "Local libraries",
        body: "Hornsby Library for Ashton; Gordon and Macquarie University libraries for Oliver.",
    },
    {
        title: "Online",
        body: "Live one-on-one sessions over Google Meet — same structure, same tutors, from anywhere.",
    },
];
